import { z } from 'zod';

import { TypeCountryLocale } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const CountryLocaleEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    fullName: z.string(),
    shortName: z.string()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export const LocalizedCountryLocaleEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    fullName: z.record(z.string(), z.string()),
    shortName: z.record(z.string(), z.string())
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateCountryLocaleEntry(data: TypeCountryLocale) {
  return CountryLocaleEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateCountryLocaleEntries(data: TypeCountryLocale[]) {
  return z.array(CountryLocaleEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterCountryLocaleEntries(data: TypeCountryLocale[]) {
  if (!data) return [];

  return data.reduce((acc: TypeCountryLocale[], entry) => {
    const validationResult = validateCountryLocaleEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeCountryLocale);
    } else {
      console.warn(
        `Validation failed for country locale entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
